import { render } from "./SchemaMarkupDropdown.vue?vue&type=template&id=bb96490a"
import script from "./SchemaMarkupDropdown.vue?vue&type=script&lang=js"
export * from "./SchemaMarkupDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__